export const experimentsGermanLocalization = {
  greeting: 'Hallo Deutsch',
  crash: 'Absturz',
  sentryMessage: 'Sentry-Message senden',
  error: 'Fehler',
  debugMessage: 'Debug-Message',
  clearBadges: 'Clear Badges',
  setBadges: 'Set Funk',
  features: 'Features',
  extensionDebugFrame: 'Extension Debug Frames',
  triggerStatisticsEmailWeekly: 'Statistik-Mail (WEEKLY) triggern',
  triggerStatisticsEmailMonthly: 'Statistik-Mail (MONTHLY) triggern',
  triggerStatisticsEmailSuccess:
    'Statistik-Mail ({{frequency}}): {{totalSent}} Mails versendet ({{organizationsConsidered}} Orgs geprüft).'
};

// Guarantees that both translations have the same structure
type ExperimentsLocales = typeof experimentsGermanLocalization;

export const experimentsEnglishLocalization: ExperimentsLocales = {
  greeting: 'Hello English',
  crash: 'Crash',
  sentryMessage: 'Send Sentry-Message',
  error: 'Error',
  debugMessage: 'Debug-Message',
  clearBadges: 'Clear Badges',
  setBadges: 'Set Funk',
  features: 'Features',
  extensionDebugFrame: 'Extension Debug Frames',
  triggerStatisticsEmailWeekly: 'Trigger statistics email (WEEKLY)',
  triggerStatisticsEmailMonthly: 'Trigger statistics email (MONTHLY)',
  triggerStatisticsEmailSuccess:
    'Statistics email ({{frequency}}): {{totalSent}} mails sent ({{organizationsConsidered}} orgs considered).'
};
